import axios from 'axios'
import store from '@/store'
import router from '@/router'
import {
    Message
} from 'element-ui';

const server = axios.create({
    baseURL: window.configUrl[process.env.NODE_ENV].apiUrl,
    timeout: 0,
    headers: {
        'Content-Type': 'application/json',
        'token': sessionStorage.getItem('token')
    },
    withCredentials: false,

})
// 请求拦截
server.interceptors.request.use(config => {
    config.headers.token = sessionStorage.getItem('token')
    return config
}, error => {
    return Promise.reject(error)
})
// 响应拦截
server.interceptors.response.use(res => {
    if (res.data.status == 200) {
        if (typeof res.data.data === 'string') {
            res.data.data = res.data.data && eval(`(${res.data.data})`);
        }
        // res.data.data = res.data.data && eval(`(${res.data.data})`);
    }
    // 防止重复报登录过期

    if (sessionStorage.getItem('err') === 'true') return
    if (res.data.status == 60025 && router.history.current.path !== '/login') {
        Message.error('登录已过期')
        store.dispatch("logOut");
        sessionStorage.setItem('err', 'true')
    } else if (res.data.status !== 200 && res.data.status !== 60025 && res.data.status !== 100000 && window.configUrl.error[res.data.status]) {
        if (document.getElementsByClassName("el-message")[0] == undefined) {
            Message.error(window.configUrl.error[res.data.status])
        }

    }
    return res.data

}, error => {
    return Promise.reject(error)
})

export default server